import styles from "./AssessReports.module.css";

import IconAndName from "../../components/IconAndName/IconAndName";

import { FaUserPlus, FaUpload } from "react-icons/fa";
import { useState } from "react";

import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import { IoAddCircleOutline } from "react-icons/io5";
import CopyRight from "../../components/CopyRight/CopyRight";

import AssessmentProgressReport from "../../sections/AssessReportsSection/AssessmentProgressReport/AssessmentProgressReport";
import AssessmentReport from "../../sections/AssessReportsSection/AssessmentReport/AssessmentReport";
import ComparisonReport from "../../sections/AssessReportsSection/ComparisonReport/ComparisonReport";
import ClassMileStoneReport from "../../sections/AssessReportsSection/ClassMileStoneReport/ClassMileStoneReport";
import StudentsMilestone from "../../sections/AssessReportsSection/StudentsMilestone/StudentsMilestone";
import StudentsProgressReport from "../../sections/AssessReportsSection/StudentsProgressReport/StudentsProgressReport";

const AssessReports = () => {
  // default or make it dynamic later



  const handleAssessments = () => {
    dispatch(openModal("hodidayCalendar"));
  };

  const dispatch = useDispatch();

  const [activeTab, setActiveTab] = useState("Assessment progress report");

  const tab = [
    {
      label: "Assessment progress report",
      content: <AssessmentProgressReport />,
    },
    {
      label: "Assessment report",
      content: <AssessmentReport />,
    },
    {
      label: "Comparison report",
      content: <ComparisonReport />,
    },
    {
      label: "Class milestone report",
      content: <ClassMileStoneReport />,
    },
    {
      label: "Students milestone",
      content: <StudentsMilestone />,
    },
    {
      label: "Students progress report",
      content: <StudentsProgressReport />,
    },
  ];

  return (
    <>
      <div className={styles.background}>
        
          <div className={styles.buttonRow}>
            <div>
              <IconAndName
                icon={<IoAddCircleOutline />}
                title="Create Assessments"
                bgColor="Primary_Color"
                onClick={handleAssessments}
              />
            </div>
          </div>
        
        <div className={styles.StudentSection}>
          <div className={styles.maincontainer}>
            <div className={styles.container}>
              {/* <TabSwitch tabs={tab} /> */}
              {tab.map((item, index) => {
                return (
                  <div
                    key={index}
                    className={`${styles.tabOptions} ${
                      activeTab === item.label && styles.ActivetabOption
                    }`}
                    onClick={() => setActiveTab(item.label)}
                  >
                    {item.label}
                  </div>
                );
              })}
            </div>
          </div>
          {tab.map((item) =>
            activeTab === item.label ? <>{item.content}</> : null
          )}
        </div>
      </div>
      <div>{<CopyRight />}</div>
    </>
  );
};

export default AssessReports;
